import * as React from "react";
import { KeyboardEvent, KeyboardEventHandler } from "react";
import { commonClientResx } from "../../resxDist/commonClientResx";
import { Input, InputProps, inputTheme } from "../inputs/Input";

interface SearchFieldProps extends InputProps {
    value: string;
    onFilterTextChange: (value: string) => void;
    onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
    onFocus?: () => any;
    theme?: inputTheme | inputTheme[];
    canCreate?: boolean;
    placeholder?: string;
}

export class SearchField extends React.Component<SearchFieldProps> {
    static defaultProps: Partial<SearchFieldProps> = {
        theme: inputTheme.input_search,
    };

    inputRef = React.createRef<Input>();

    constructor(props: SearchFieldProps) {
        super(props);
        this.handleFilterTextChange = this.handleFilterTextChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    focus = () => {
        this.inputRef.current?.focusInput(false);
    };

    handleFilterTextChange(inputValue: string) {
        this.props.onFilterTextChange(inputValue);
    }

    handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
        if (this.props.onKeyDown) {
            this.props.onKeyDown(event);
        }
    }

    getDefaultPlaceholder() {
        return this.props.canCreate ? commonClientResx.Type_for_search_or_add : commonClientResx.Type_for_search;
    }

    render() {
        const placeholder = this.props.placeholder ?? this.getDefaultPlaceholder();

        return (
            <Input
                refCallback={this.props.refCallback}
                autoFocus={false}
                value={this.props.value}
                autoComplete={"off"}
                theme={this.props.theme}
                onChangeAction={this.handleFilterTextChange}
                onKeyDown={this.handleKeyDown}
                onFocusAction={this.props.onFocus}
                placeholder={placeholder}
                maxLength={this.props.maxLength}
                ref={this.inputRef}
            />
        );
    }
}
